import { memo } from "react";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { SplitVersionRow } from "../views/splitVersionsViewConfig";

interface SplitCountCellProps {
    row: { original: SplitVersionRow };
}

export const SplitCountCell = memo(({ row }: SplitCountCellProps) => (
    <ViewTableCell>{row.original.splitsCount}</ViewTableCell>
));

SplitCountCell.displayName = "SplitCountCell";
